import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=5ceb64a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ceb64a0"]])

export default __exports__